<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de sedes" icon="fas fa-coins" btn_name="Sede" @mtdBack="mtdBack" @show_modal="mtd_open_modal"
          @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'" :button_new="true" :actions="true"
          :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
      <CRow>
        <CCol sm="12">
          <cSelectForm label="Empresa" placeholder="Seleccione empresa" :options="data_companies"
            :value.sync="campu.company_id" :disabled="this.$store.getters.get_all_user.id !== 1" />
        </CCol>
        <CCol sm="12">
          <CInput label="Nombre" placeholder="Digite nombre" v-model="campu.name" />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="campu.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
            v-bind="labelIcon" />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Rol'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "Empresa", _style: "width:1%" },
  { key: "Nombre", _style: "width:20%;" },
  { key: 'status', label: "Estado", _style: "width:5%;" }
];

import CTableWrapper from "../../components/shared/datatable/Table.vue";
import CModalForm from "../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../components/shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CSwitch } from '@coreui/vue-pro';
import CSwitchVue from '../shared/switch/CSwitch.vue';
import cSelectForm from '../../components/shared/inputs/cSelect.vue';

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue, cSelectForm },
  data() {
    return {
      prefix: "campus",
      fields,
      data: [],
      data_companies: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      campu: {
        id: "",
        name: "",
        user_id: this.$store.getters.get__user_id,
        company_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_company.id,
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      componentKey: 0,
      dataStore: []
    };
  },
  computed: {
    cpStatus: function () {
      if (this.campu.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.campu.name != "") return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.indexCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
  
    indexCampus: function () {
      this.get({
        url: this.$store.getters.get__url + "/campus/company",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.forEach((element) => {
            this.data_companies.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => { });
    },
    mtd_getdata: function () {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix +"/index/"+ this.$store.getters.get__user_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          this.dataStore = response.data.all;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nueva Sede")
        : (this.modal.title = "Editar Sede");
      action == "store"
        ? (this.campu = {
          id: "",
          name: "",
          user_id: this.$store.getters.get__user_id,
          company_id: this.$store.getters.get_all_user.id == 1
            ? ""
            : this.$store.getters.get_company.id,
          state: "",
        })
        : (this.campu = this.campu);
      if (this.modal.action != 'store') {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.campu,
      })
        .then((response) => {
          let color = "success";
          let message = "";
          if (response.data.state == 1) {
            Swal.fire({
              title: "Sede ya resgistrada",
              icon: "warning",
            });
          } else {
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              this.data.forEach((element) => {
                if (element.Id == response.data.data[0].Id) {
                  element.Nombre = response.data.data[0].Nombre;
                  element.status = response.data.data[0].status;
                }
                message = "EDITADO CORRECTAMENTE";
              });
            }
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            name: "",
          };
          this.dataStore = response.all;
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.campu = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => { });
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          this.dataStore = response.all;
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => { });
    },
    changeSwitch: function (payload) {
      this.campu.state = payload == true ? 1 : 0;
    }
  },
  destroyed() {
    // console.log(this.dataStore);
    this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
